import {
  Broadcast,
  ChartLine,
  Coins,
  Truck,
  ShoppingCart,
  Calendar,
} from "phosphor-react";
import React from "react";
import { RiBardFill } from "react-icons/ri";

const GroupOrders = () => {
  const newLine = `\n\n`
  return (
    <>
      <section className="container mx-auto px-4 flex flex-col items-center justify-center md:w-[75%] xl:mt-[170px] mt-16">
        <div className="inline-flex  items-center bg-light-purple-100 gap-2.5 px-5 py-2 rounded-full mx-auto justify-center xl:py-[15px] xl:px-[30px]">
          <RiBardFill className="text-light-purple-600 text-2xl md:block hidden" />
          <p className="font-inter text-xs md:text-lg text-green-950 font-medium">
            Group Order
          </p>
        </div>
        <p className="font-sora text-center text-[30px] leading-[40px] font-semibold my-4 xl:my-5 xl:text-5xl xl:leading-[60px]">
          How Group Order Works
        </p>
        <p className="text-sm leading-[22px] text-center font-inter xl:text-xl xl:leading-[30px] max-w-[1024px]">
          We all buy the same essentials - water, groceries, household supplies - but individually. This means we miss out on bulk discounts that big buyers enjoy. {newLine}
          That’s why we created the Marketplace - a smarter way to shop. By buying together, we unlock lower prices and get everything delivered conveniently to our doorsteps.
        </p>
        <p className="text-sm italic mt-3 leading-[22px] text-center font-inter xl:text-xl xl:leading-[30px] max-w-[1024px]">
          PS: Need to buy individual items in a hurry? Can't wait for market day? That's also possible on the Venco marketplace. Just choose the <span className="font-semibold">“Faster Delivery”</span> option when adding to your cart. 
        </p>
      </section>
      <section
        className="mt-8 xl:mt-[70px] mb-12 lg:container lg:mx-auto lg:p-4 flex flex-wrap gap-[30px] justify-center p-4"
        data-aos="fade-up"
        data-aos-delay="20"
      >
        {[
          {
            title: "Browse & Add to Cart",
            desc: "Shop from a curated list of essentials for your household or community.",
            icon: <ShoppingCart weight="fill" className="text-[40px]" />,
          },
          {
            title: "Group Order Window",
            desc: "Join your community’s weekly order window. More buyers = lower prices.",
            icon: <Calendar weight="fill" className="text-[40px]" />,
          },
          {
            title: "Delivery to Your Door",
            desc: "Receive your items in a single, convenient delivery. Easy and fast.",
            icon: <Truck weight="fill" className="text-[40px]" />,
          },
        ].map((item, index) => {
          return (
            <div class="bg-light-purple-50 p-7 rounded-xl md:p-10 xl:p-[50px] md:max-w-[340px] 2xl:max-w-[400px]">
              <div class="bg-light-purple-100 text-light-purple-500 rounded-full w-[120px] h-[120px] center innerShadow">
                {item.icon}
              </div>
              <div className="h-[60px]"></div>
              <div className="space-y-7">
                <p className="font-sora text-[22px] font-semibold">
                  {item.title}
                </p>
                <p className="font-inter leading-[150%]">{item.desc}</p>
              </div>
            </div>
          );
        })}
      </section>
    </>
  );
};

export default GroupOrders;
